module.exports = "/images/935039658defa51d4aebceb357fa24e5.png";